webpackJsonp([89],{

/***/ 2694:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign__ = __webpack_require__(62);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends__ = __webpack_require__(39);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends__);


//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/* harmony default export */ __webpack_exports__["a"] = ({
  data: function data() {
    return {
      id: null,
      inputWith: 12,
      formRules: {
        name: [{ required: true, message: '群组批次描述不能为空', trigger: 'blur' }],
        batchid: [{ required: true, message: '批次编号不能为空', trigger: 'blur' }],
        customerid: [{ required: true, message: '客户编号不能为空', trigger: 'blur' }],
        projectid: [{ required: true, message: '项目编号不能为空', trigger: 'blur' }],
        group_type: [{ required: true, message: '请选择群组类型', trigger: 'change' }]
      },
      dataModel: {
        id: '',
        customerid: '',
        projectid: '',
        batchid: '',
        name: '',
        platform_admin_ids: '',
        group_type: 1,
        tenant_customerid: this.$route.params.tenant_customerid
      },
      inLoading: {
        customerid: false,
        projectid: false,
        batchid: false
      }
    };
  },
  beforeRouteEnter: function beforeRouteEnter(to, from, next) {
    next(function (vm) {
      return vm.onLoad();
    });
  },
  beforeRouteUpdate: function beforeRouteUpdate(to, from, next) {
    this.onReload();
    next();
  },
  created: function created() {},


  methods: __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends___default()({}, request.map(['getBatchTable', 'getBatchDetail', 'getCustomerTable', 'getCustomerDetail', 'getBaiscProjectTable', 'getProjectDetail', 'getBasicPlatformUsersIndex', 'getPlatformUsersDetail']), {
    onLoad: function onLoad() {
      if (this.$route.params.id) {
        this.setForm(this.id = this.$route.params.id);
      }
    },
    onReload: function onReload() {
      __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign___default()(this.$data, this.$options.data());
      this.onLoad();
    },
    setForm: function setForm(id) {
      var _this = this;

      request.page('getGroupBatchDetail', { id: id }).then(function (_ref) {
        var data = _ref.data;

        data.customerid += '';
        data.group_type = Number(data.group_type || 1);
        filter.setLoop(_this.dataModel, data);
      });
    },
    onChangeProjectId: function onChangeProjectId() {
      this.dataModel.batchid = '';
    },
    onSubmit: function onSubmit() {
      var _this2 = this;

      this.$refs.form.validate(function (valid) {
        if (!valid) {
          _this2.$message.error('提交内容填写不正确！');
          return;
        }

        var submitApi = _this2.$route.params.id ? 'updateGroupBatchData' : 'createGroupBatchData';

        var submitModel = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends___default()({}, _this2.dataModel);
        if (_this2.$route.params.id) {
          submitModel.id = _this2.$route.params.id;
        } else {
          // 默认开启差值限制
          submitModel.redundant_taskcnt_restrict = 1;
        }

        request.common(submitApi, submitModel).then(function (res) {
          _this2.$router.go(-1);
        });
      });
    },
    onCancel: function onCancel() {
      this.$router.go(-1);
    },

    unionBy: _.unionBy
  })
});

/***/ }),

/***/ 293:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_GroupBatchForm_vue__ = __webpack_require__(2694);
/* empty harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_18c8aa76_hasScoped_true_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_GroupBatchForm_vue__ = __webpack_require__(4078);
function injectStyle (ssrContext) {
  __webpack_require__(4072)
  __webpack_require__(4074)
  this["$style"] = __webpack_require__(4076)
}
var normalizeComponent = __webpack_require__(11)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-18c8aa76"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_GroupBatchForm_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_18c8aa76_hasScoped_true_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_GroupBatchForm_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["default"] = (Component.exports);


/***/ }),

/***/ 4072:
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(4073);
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var update = __webpack_require__(991)("672760a1", content, true, {});

/***/ }),

/***/ 4073:
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(990)(true);
// imports


// module
exports.push([module.i, "", "", {"version":3,"sources":[],"names":[],"mappings":"","file":"GroupBatchForm.vue","sourceRoot":""}]);

// exports


/***/ }),

/***/ 4074:
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(4075);
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var update = __webpack_require__(991)("1e698eab", content, true, {});

/***/ }),

/***/ 4075:
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(990)(true);
// imports


// module
exports.push([module.i, "", "", {"version":3,"sources":[],"names":[],"mappings":"","file":"GroupBatchForm.vue","sourceRoot":""}]);

// exports


/***/ }),

/***/ 4076:
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(4077);
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var update = __webpack_require__(991)("aa5ca6d2", content, true, {});

/***/ }),

/***/ 4077:
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(990)(true);
// imports


// module
exports.push([module.i, "", "", {"version":3,"sources":[],"names":[],"mappings":"","file":"GroupBatchForm.vue","sourceRoot":""}]);

// exports


/***/ }),

/***/ 4078:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{directives:[{name:"title",rawName:"v-title",value:(_vm.$route.meta.title),expression:"$route.meta.title"}]},[_c('div',{staticClass:"page-heading"},[_c('el-breadcrumb',{attrs:{"separator-class":"el-icon-arrow-right"}},[_c('el-breadcrumb-item',{attrs:{"to":"/"}},[_vm._v("首页")]),_vm._v(" "),_c('el-breadcrumb-item',[_vm._v("群组控制")]),_vm._v(" "),_c('el-breadcrumb-item',[_vm._v(_vm._s(_vm.$route.meta.title))])],1)],1),_vm._v(" "),_c('layout-panel',[_c('span',{attrs:{"slot":"header"},slot:"header"},[_vm._v("表单")]),_vm._v(" "),_c('el-form',{ref:"form",attrs:{"model":_vm.dataModel,"rules":_vm.formRules,"size":"medium","label-width":"140px"}},[_c('div',{staticClass:"re-el-form__flex"},[_c('div',{staticClass:"medium"},[_c('el-form-item',{attrs:{"prop":"name","label":"群组批次描述"}},[_c('el-input',{model:{value:(_vm.dataModel.name),callback:function ($$v) {_vm.$set(_vm.dataModel, "name", $$v)},expression:"dataModel.name"}})],1),_vm._v(" "),_c('el-form-item',{attrs:{"label":"客户名称/编号","prop":"customerid"}},[_c('remote-select',{attrs:{"id-key":"number","label-key":"name","value-key":"id","query-request":_vm.getCustomerTable,"find-request":_vm.getCustomerDetail,"clearable":"","disabled":!!_vm.dataModel.id},model:{value:(_vm.dataModel.customerid),callback:function ($$v) {_vm.$set(_vm.dataModel, "customerid", $$v)},expression:"dataModel.customerid"}})],1),_vm._v(" "),_c('el-form-item',{attrs:{"label":"项目名称/编号","prop":"projectid"}},[_c('remote-select',{attrs:{"id-key":"number","label-key":"name","value-key":"id","placeholder":"请输入项目名称/编号搜索","disabled":!_vm.dataModel.customerid || Boolean(_vm.dataModel.id),"query-request":_vm.getBaiscProjectTable,"query-params":{customerid: _vm.dataModel.customerid},"find-request":_vm.getProjectDetail,"clearable":""},on:{"change":_vm.onChangeProjectId},model:{value:(_vm.dataModel.projectid),callback:function ($$v) {_vm.$set(_vm.dataModel, "projectid", $$v)},expression:"dataModel.projectid"}})],1),_vm._v(" "),_c('el-form-item',{attrs:{"prop":"batchid","label":"批次名称/编号"}},[_c('remote-select',{staticClass:"width-max",attrs:{"clearable":"","id-key":"number","label-key":"detail","value-key":"id","multiple":true,"placeholder":"请输入批次关键字","disabled":!_vm.dataModel.projectid,"query-request":function (_){ return _vm.getBatchTable(Object.assign({customerid: _vm.dataModel.customerid, projectid:_vm.dataModel.projectid, per_page: 100}, _)); },"find-request":_vm.getBatchDetail},model:{value:(_vm.dataModel.batchid),callback:function ($$v) {_vm.$set(_vm.dataModel, "batchid", $$v)},expression:"dataModel.batchid"}})],1),_vm._v(" "),_c('el-form-item',{attrs:{"label":"管理员","prop":"platform_admin_ids"}},[_c('el-col',[_c('remote-select',{staticClass:"width-max",attrs:{"clearable":"","multiple":"","multiple-limit":5,"id-key":"id","label-key":"name","keyword-key":"name","value-key":"id","placeholder":"请输入管理员","query-request":function (_){ return _vm.getBasicPlatformUsersIndex(Object.assign({customerid: _vm.dataModel.customerid}, _)); },"find-request":_vm.getPlatformUsersDetail},model:{value:(_vm.dataModel.platform_admin_ids),callback:function ($$v) {_vm.$set(_vm.dataModel, "platform_admin_ids", $$v)},expression:"dataModel.platform_admin_ids"}})],1)],1),_vm._v(" "),_c('el-form-item',{attrs:{"label":"群组类型","prop":"group_type"}},[_c('el-radio-group',{attrs:{"disabled":!!_vm.dataModel.id},model:{value:(_vm.dataModel.group_type),callback:function ($$v) {_vm.$set(_vm.dataModel, "group_type", $$v)},expression:"dataModel.group_type"}},[_c('el-radio',{attrs:{"label":2}},[_vm._v("按项目")]),_vm._v(" "),_c('el-radio',{attrs:{"label":1}},[_vm._v("按客户")])],1)],1)],1)]),_vm._v(" "),_c('el-form-item',[_c('el-button',{on:{"click":_vm.onCancel}},[_vm._v("取消\n        ")]),_vm._v(" "),_c('el-button',{attrs:{"type":"primary"},on:{"click":_vm.onSubmit}},[_vm._v("保存\n        ")])],1)],1)],1)],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ })

});


// WEBPACK FOOTER //
// static/js/group-batch-form.148af7f48f8088413557.js